export const general = {
  upload: {
    file_name: "Nom du fichier",
    file_size: "Taille du fichier",
    file_invalid_type: "Le type de fichier doit être {{messageSuffix}}",
    file_too_large: "Le fichier est plus volumineux que {{maxSize}}{{unit}}",
    file_too_small: "Le fichier est plus petit que {{minSize}}{{unit}}",
    too_many_files: "Trop de fichiers, seulement {{maxFiles}} autorisés",
    rejected_header: "Fichiers rejetés",
    release_drop: "Glissez et déposez le fichier ici",
    select_from_your_computer: "ou sélectionnez depuis votre ordinateur",
  },
  table: {
    reset_table_layout: "Réinitialiser la mise en page du tableau",
  },
  access_denied: "Vous n'avez pas accès à cette page",
  assign_selected: "Assigner la sélection",
  Link: "Lien",
  similarity: {
    High: "Élevé",
    Low: "Faible",
    Medium: "Moyen",
    Very_high: "Très élevé",
    Very_low: "Très faible",
    score: "Score de similarité",
  },
  show: "Afficher",
  hide: "Masquer",
  this_action_cannot_be_undone: "Cette action ne peut pas être annulée",
  continue: "Continuer",
  current: "Actuel",
  latest: "Dernier",
  download_excel: "Télécharger Excel",
  changes: "Modifications",
  compare: "Comparer",
  tenant_not_provided_for_current_user:
    "Locataire pour l'utilisateur actuel non fourni. Vérifiez la configuration de la vue (fonction de point de terminaison).",
  overview: "Aperçu",
  only_paying_customers_can_access_this_feature: "Seuls les clients payants peuvent accéder à cette fonctionnalité",
  add_file_url: "Ajouter l'URL du fichier",
  add_file_URL_button: "Bouton ajouter URL de fichier",
  Alert: "Alerte",
  All: "Tout",
  other: "Autre",
  All_changes_have_been_saved: "Toutes les modifications ont été enregistrées.",
  All_sub_themes: "Tous les sous-thèmes",
  All_themes: "Tous les thèmes",
  Apply: "Appliquer",
  Approve: "Approuver",
  are_you_sure: "Êtes-vous sûr ?",
  Assessment: "Évaluation",
  Assessments: "Évaluations",
  Back: "Retour",
  Cancel: "Annuler",
  close: "Fermer",
  Clear_all: "Tout effacer",
  Collapse_all: "Réduire tout",
  Companies: "Entreprises",
  Confirm: "Confirmer",
  Dashboard: "Tableau de bord",
  Declined: "Refusé",
  Delete: "Supprimer",
  Description: "Description",
  Deselect_all: "Tout désélectionner",
  Documentation: "Documentation",
  Duplicate: "Dupliquer",
  Edit: "Modifier",
  Email: "Email",
  Error: "Erreur",
  Expand_all: "Développer tout",
  File: "Fichier",
  First_name: "Prénom",
  Help: "Aide",
  hide_menu: "Masquer le menu",
  Important_Notice: "Avis important",
  Incorrect_data: "Données incorrectes",
  Job_title: "Titre du poste",
  Last_update: "Dernière mise à jour",
  load_more: "charger plus",
  Next: "Suivant",
  No: "Non",
  no_answer: "Pas de réponse",
  No_results: "Aucun résultat",
  Notifications: "Notifications",
  Ok: "Ok",
  Open_settings: "Ouvrir les paramètres",
  or: "ou",
  Proceed: "Continuer",
  Protocol: "Protocole",
  Remove: "Supprimer",
  Reports: "Rapports",
  Reset_to_default: "Réinitialiser par défaut",
  Reviewers: "Réviseurs",
  Role: "Rôle",
  roles: {
    Data_provider: "Fournisseur de données",
    data_providers: "Fournisseurs de données",
    reviewer: "réviseur",
    Reviewer: "Réviseur",
    Verifier: "Vérificateur",
  },
  Roles: "Rôles",
  Row: "Ligne",
  Save: "Enregistrer",
  Saving: "Enregistrement...",
  search: "rechercher",
  Search: "Rechercher",
  Search_bar: "Barre de recherche",
  Select: "Sélectionner",
  Select_all: "Tout sélectionner",
  show_menu: "Afficher le menu",
  Show_more: "Afficher plus",
  show_less: "Afficher moins",
  Site: "Site",
  Site_creation: "Création de site",
  Site_edition: "Modification de site",
  Sites: "Sites",
  Standard: "Norme",
  standards: "normes",
  SupportPortal: "Portail de support",
  Surname: "Nom de famille",
  there_are_no_files: "Il n'y a aucun fichier.",
  This_field_is_required: "Ce champ est obligatoire",
  "Type_name_surname_or_e-mail": "Tapez nom, nom de famille ou e-mail",
  Type_search_text_here: "Tapez le texte de recherche ici",
  Type_to_search: "Tapez pour rechercher",
  Unsaved_Changes: "Modifications non enregistrées",
  Upload: "Télécharger",
  Url: "URL",
  Users: "Utilisateurs",
  validation: {
    At_last_one_site_is_required: "Au moins un site est requis",
    At_last_one_standard_is_required: "Au moins une norme est requise",
    Coordinator_is_required: "Un coordinateur est requis",
    Country_is_required: "Le pays est requis",
    Email_is_used_in_another_company: "L'email est utilisé dans une autre entreprise",
    Incorrect_email: "Email incorrect",
    name_is_required: "Le nom est requis.",
    Scope_of_applicability_is_required: "Le champ d'application est requis",
    site_is_required: "Le site est requis.",
    this_field_is_required: "Ce champ est obligatoire.",
    This_field_must_be_unique: "Ce champ doit être unique.",
  },
  Yes: "Oui",
  You_have_unsaved_changes_Are_you_sure_you_want_to_leave:
    "Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir partir ?",
  ai_disclaimer: {
    title: "Avis de traduction IA",
    message:
      "Cette traduction des questions du protocole et des exigences de la norme a été générée à l'aide d'outils d'intelligence artificielle et peut contenir des inexactitudes.",
    accept: "Je comprends",
    go_back: "Retour",
    switch_to_english: "Passer à l'anglais",
  },
} as const;
